import styles from "./AdditionalSettings.module.scss";
import cn from "classnames";
import SerialNumber from "./SerialNumber/SerialNumber";
import MinerModel from "./MinerModel/MinerModel";
import MinerInstallDate from "./MinerInstallDate/MinerInstallDate";

export default function AdditionalSettings() {
  return (
    <>
      {/*<SerialNumber />*/}
      {/* <MinerModel /> */}
      <MinerInstallDate />
    </>
  );
}
